import { CSSProperties } from "react";
import { ITokenUsage, GenerativeServiceType, BKLLMConfigType } from "./types";

export enum APP_TYPE  {
   ENTRY_FIELD_APP = "entry-field-app",
   INLINE_APP = "inline-app",
   TEXT_GENERATION = "text-generation",
   IMAGE_GENERATION = "image-generation",
}

export enum TEXT_GENERATION_TYPE  {
  GENERATE_WITH_CONTEXT = "generate_with_context",
  GENERATE_WITHOUT_CONTEXT = "generate_without_context"
}

export const COLORS = {
   active: "#475161",
   disabled: "#A9B6CB",
   purple: "#6C5CE7",
   white: "#fff"
}

export const IMAGE_GENERATION_MODAL_PROPS = {
   size: 'max',
   style: {
     content: {
       height: 650,
       maxHeight: 650
     }
   }
 }

export const TEXT_OVERLAY_PROPS ={
  size: 'max',
  style: {
    content: {
      width: '76.5rem',
      height: '40rem',
      maxHeight: '40rem'
    }
  }
}

 export const IMAGE_MODAL_BODY_STYLE: CSSProperties = {
  maxHeight: "none",
  padding: "1.5rem 1.5rem",
  borderRadius: "0.5rem",
 }

export const IMAGES_PER_PAGE = 4;

export const IMAGE_GENERATION_COUNT = 4;

export const FETCHING_IMAGE_MSG = "Fetching image...";
export const IMAGE_LOADING_MSG = "Generating your images";

export enum TEXT_PROVIDER {
  OPENAI = "openai",
  AZURE_OPENAI = "azure_openai",
  AWS_BEDROCK = "aws_bedrock",
  VERTEX_AI = "vertex_ai",
  GEMINI = "gemini"
}

export const DEFAULT_OPENAI_TEXT_MODEL = "gpt-4o";
export const DEFAULT_OPENAI_IMAGE_MODEL = "dall-e-2";

// field name service_type is as per align-backen naming convention.
export const DefaultBKLLMConfig: BKLLMConfigType = {
  model: DEFAULT_OPENAI_TEXT_MODEL,
  provider: TEXT_PROVIDER.OPENAI,
  service_type: [GenerativeServiceType.TEXT_GENERATION, GenerativeServiceType.CONVERSE],
  model_type: 'recommended',
}

export const DefaultAIAssistantProvider = {
  value: TEXT_PROVIDER.OPENAI,
  label: 'OpenAI',
}

export const DefaultAIAssistantModel = {
  value: DEFAULT_OPENAI_TEXT_MODEL,
  label: DEFAULT_OPENAI_TEXT_MODEL,
  service_types: [GenerativeServiceType.TEXT_GENERATION, GenerativeServiceType.CONVERSE],
}

export const DefaultImageAssistantModel = {
  value: DEFAULT_OPENAI_IMAGE_MODEL,
  label: DEFAULT_OPENAI_IMAGE_MODEL,
  service_types: [GenerativeServiceType.IMAGE_GENERATION, GenerativeServiceType.IMAGE_EDIT],
}

export const IMAGE_EDIT_MODEL = [
  "dall-e-2",
  "imagen-3.0-generate-001"
]

export const CONVERSATIONAL_MODEL_CONTEXT_SIZE = {
  "gpt-3.5-turbo": 16385,
  "gpt-4": 8192,
  "gemini-1.5-pro": 2097152,
  // "anthropic.claude-3-sonnet-20240229-v1:0": 200000,
  // "anthropic.claude-3-haiku-20240307-v1:0": 200000
}

export const CONVERSATIONAL_MODEL = [
  "gpt-3.5-turbo",
  "gpt-4",
  "gemini-1.5-pro",
]

export const BEDROCK_SUPPORTED_TEXT_MODEL = [
  "amazon.titan-tg1-large",
  "anthropic.claude-instant-v1",
  "anthropic.claude-v1",
  "anthropic.claude-v2",
  // "anthropic.claude-3-haiku-20240307-v1:0",
  // "anthropic.claude-3-sonnet-20240229-v1:0"
]

export const INITIAL_TOKEN_USAGE: ITokenUsage = {
  inputTokenLength: 0,
  outputTokenLength: 0
}

export enum EXPERIENCE_TYPE {
  AB_TEST = "AB_TEST",
  SEGMENTED = "SEGMENTED"
}

export enum LLM_MODEL_TYPE {
  RECOMMENDED = 0,
  ADVANCE = 1
}

export const SERVICE_TYPE_LABEL = {
  [GenerativeServiceType.TEXT_GENERATION] : 'text',
  [GenerativeServiceType.CONVERSE]: 'conversation',
  [GenerativeServiceType.IMAGE_GENERATION]: 'image',
  [GenerativeServiceType.IMAGE_EDIT]: 'image'
}

export enum STORAGE_KEYS {
  LOCALES = 'locales',
}

export const MANAGED_BY_USER = 'managed_by_user';
export const MANAGED_BY_CS = 'managed_by_cs';

export const ERRORS = {
  FAILED_IMAGE_GENERATION: 'Failed to generate image',
  FAILED_IMAGE_EDIT: 'Failed to edit image',
}

export const SUPPORTED_IMAGE_GEN_MODELS = ["dall-e-2", "dall-e-3", "imagen-3.0-generate-001"];

export const llmMappings = {
  "ai21.j2": "AI21 Labs",
  "ai21.jamba": "AI21 Labs",
  "amazon.nova": "Amazon",
  "amazon.titan": "Amazon",
  "anthropic.claude": "Anthropic",
  "cohere.command": "Cohere",
  "cohere.embed": "Cohere",
  "meta.llama3": "Meta",
  "mistral.mistral": "Mistral AI",
  "mistral.mixtral": "Mistral AI",
  "stability.stable-diffusion": "Stability AI",
};

export const DEFAULT_APP_CONFIG = {
    mode: "managed_by_cs",
    isBrandkitEnabled: false,
};

// enums/FieldType.ts
export enum FIELD_TYPE {
  Modifier = 'field_modifier',
  RTE = 'json_rte',
}

export const SUBMENU_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
};